import { GlobalToken } from 'antd';

export const getIconSize = (size: 'small' | 'large', token: GlobalToken) => {
  switch (size) {
    case 'small':
      return `${token.fontSizeHeading2}px`;
    case 'large':
      return `${token.fontSizeHeading1}px`;
  }
};
